import React from 'react'

import welcome from 'src/images/welcome.svg'


const TrialSignupBanner = ({ onClick }) => {
  return (
    <div>
      <div className="col intro_card prioritize-container">
        <div className="row no-gutters trial_signup">
          <div className=" icon_wrapper">
            <img src={welcome} alt="icon" />
          </div>
          <div style={{padding: '0 20px'}}>
            <h2 className="heading">Welcome to POPin!</h2>
            <p>Want to create your own sessions? Start a 14-Day Trial today! Use the live Help chat if you have questions on how it works.</p>
          </div>
          <button
            onClick={onClick}
            style={{ boxShadow: 'none' }}
            className=" btn btn-lg btn-primary btn-submit"
          >
            Sign Up Now
          </button>
        </div>
      </div>
    </div>
  )
}

export default TrialSignupBanner